<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="招标项目名称" prop="tenderProjectName">
        <el-input v-model="form.tenderProjectName"></el-input>
      </el-form-item>
      <el-form-item label="项目类别" prop="projectType">
        <el-radio
          v-model="form.projectType"
          :label="item.value"
          v-for="(item, index) in projectList"
          :key="index"
          >{{ item.name }}</el-radio
        >
        <el-input
          placeholder="请输入"
          v-if="form.projectType === '其他'"
          class="width_150"
          v-model="form.projectTypeRemark"
        >
        </el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="监管部门" prop="supervisionDept">
            <el-input
              v-model="form.supervisionDept"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="投诉事项类型" prop="complaintType">
        <el-checkbox-group v-model="form.complaintType">
          <el-checkbox
            :label="item.name"
            name="type"
            v-for="(item, index) in complaints"
            :key="index"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="投诉内容摘要" prop="complaintContext">
        <el-input
          type="textarea"
          v-model="form.complaintContext"
          :autosize="{ minRows: 8 }"
        ></el-input>
      </el-form-item>
      <el-form-item label="诉求及主张" prop="appealsClaims">
        <el-input
          type="textarea"
          v-model="form.appealsClaims"
          :autosize="{ minRows: 8 }"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      complaints: [
        {
          name: '招标公告(含招标文件)'
        },
        {
          name: '开标(含投标文件递交、投标登记)'
        },
        {
          name: '评标结果(含资格审查结果、中标候选人公示、投标结果公开)'
        }
      ],
      projectList: [
        {
          name: '施工',
          value: '施工'
        },
        {
          name: '货物(设备、材料)',
          value: '货物(设备、材料)'
        },
        {
          name: '服务(勘察、设计、监理)',
          value: '服务(勘察、设计、监理)'
        },
        {
          name: '设计施工总承包',
          value: '设计施工总承包'
        },
        {
          name: '其他',
          value: '其他'
        }
      ],
      form:
        process.env.NODE_ENV === 'production'
          ? {
              tenderProjectName: '',
              projectType: '',
              supervisionDept: '',
              complaintType: [],
              complaintContext: '',
              appealsClaims: '',
              projectTypeRemark: ''
            }
          : {
              tenderProjectName: '李四',
              projectType: '施工',
              supervisionDept: '张三 ',
              complaintType: [
                '招标公告(含招标文件)',
                '开标(含投标文件递交、投标登记)'
              ],
              complaintContext: '李四',
              appealsClaims: '123',
              projectTypeRemark: '1,123'
            },

      rules: {
        tenderProjectName: [
          { required: true, message: '招标项目名称', trigger: 'blur' }
        ],
        projectType: [
          { required: true, message: '请选择项目类别', trigger: 'change' }
        ],
        supervisionDept: [
          { required: true, message: '请填写监管部门', trigger: 'blur' }
        ],
        complaintType: [
          {
            type: 'array',
            required: true,
            message: '请选择投诉事项类型',
            trigger: 'change'
          }
        ],
        complaintContext: [
          { required: true, message: '请填写投诉内容摘要', trigger: 'blur' }
        ],
        appealsClaims: [
          { required: true, message: '请填写诉求及主张', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async getContentForm() {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    }
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       alert("submit!");
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #72ad43;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #72ad43;
  background: #72ad43;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #72ad43;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #72ad43;
  background: #72ad43;
}
.width_150 {
  width: 150px;
}
</style>
